import { useFlags } from 'wsm-common-data';
import { getModelTitle } from '../utils/getModelTitle';
import { SKIP_MAKE_IN_MODEL_TITLE_FLAG } from '../global-constants';

// Returns getModelTitle with feature-flagged options already applied. It
// returns a function rather than a title so it also works inside loops.
//
// TODO(US2151661): remove SKIP_MAKE_IN_MODEL_TITLE_FLAG when it is no longer
// needed. If this still needs to be controlled per dealer after that, replace
// the flag with a widget pref and pass that as skipMakeIfInModel instead.
export const useGetModelTitle = () => {
	const flags = useFlags();
	const skipMakeIfInModel = flags[SKIP_MAKE_IN_MODEL_TITLE_FLAG];
	return (modelTitleAttributes, vehicle) =>
		getModelTitle(modelTitleAttributes, vehicle, { skipMakeIfInModel });
};
